import { FunctionComponent } from 'react';

import LayoutContainer, { Sizes } from 'components/layout/LayoutContainer';
import EmployeeRegisterForm from 'components/modules/public/layout/forms/EmployeeRegisterForm';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPageJobSectionRegister: FunctionComponent<Props> = ({
    headline,
    form,
    phoneForm,
    emailForm,
}) => {
    return (
        <StyledComponent
            className="public-page-job-section-register"
        >
            <LayoutContainer
                size={Sizes?.XMedium}
                className="content-container"
            >
                <LayoutContainer>
                    <h1
                        className="headline"
                        dangerouslySetInnerHTML={{ __html: headline }}
                    />
                    <div className="form-container">
                        <EmployeeRegisterForm
                            {...form}
                            phoneForm={phoneForm}
                            emailForm={emailForm}
                        />
                    </div>
                </LayoutContainer>
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PublicPageJobSectionRegister;